// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cs-pointer[data-v-52cc5c52] {\n    cursor: pointer;\n}\n.change-profile[data-v-52cc5c52] {\n  position: absolute;\n  left: 85px;\n  top: 100px;\n  font-weight: bold;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
